import { Spinner } from "./ui/spinner";

interface LoadingSpinnerProps {
  text?: string;
  className?: string;
}

export default function LoadingSpinner({
  text = "Loading...",
  className = "",
}: LoadingSpinnerProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center py-16 md:py-24 ${className}`}
    >
      <Spinner className="size-8 text-amber-500" />
      <p className="mt-4 text-center text-gray-600">{text}</p>
    </div>
  );
}
